<template>
  <a-card :visible="visible">
    <a-form :form="form">
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.organizationName">
        <a-input style="border:0px;" placeholder="" v-decorator="['departName', {}]"/>
      </mtc-form-item>
      <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.upperDivision">
        <a-tree-select
          disabled
          style="width:100%;border: 0px;border: none;outline:none;"
          :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
          :treeData="treeData"
          v-model="model.parentId"
          placeholder="无">
        </a-tree-select>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.organizationCode">
        <a-input style="border:0px;" placeholder="" v-decorator="['orgCode', {}]"/>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.orgType">
          <a-radio-group :disabled="true" v-decorator="['orgCategory',{}]" placeholder="请选择机构类型">
            <a-radio v-for="(item, key) in departsList" :key="key" :value="item.value">{{ item.text }}</a-radio>
          </a-radio-group>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.sort">
        <a-input-number style="border:0px;" v-decorator="[ 'departOrder',{}]"/>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.cellPhoneNumber">
        <a-input style="border:0px;" placeholder="" v-decorator="['mobile', {}]"/>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.addressOnly">
        <a-input style="border:0px;" placeholder="" v-decorator="['address', {}]"/>
      </mtc-form-item>
      <mtc-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="label.remarks">
        <a-textarea style="border:0px;" placeholder="" v-decorator="['memo', {}]"/>
      </mtc-form-item>
    </a-form>
  </a-card>
</template>
<script>
  import pick from 'lodash.pick'
  import { ajaxGetDictItems, queryIdTree } from '@/api/api'

  export default {
    name: 'DeptBaseInfo',
    components: {},
    data() {
      return {
        departsList: [],
        departTree: [],
        id: '',
        model: {},
        visible: false,
        disable: true,
        treeData: [],
        form: this.$form.createForm(this),
        labelCol: {
          xs: {span: 24},
          sm: {span: 3}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
      }
    },
    created() {
      this.loadTreeData();
      this.initDepartList()
    },
    methods: {
      initDepartList(){
        ajaxGetDictItems('org_category', null).then((res) => {
          if (res.success) {
            this.departsList = res.result;
          }
        });
      },
      loadTreeData() {
        queryIdTree().then((res) => {
          if (res.success) {
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              this.treeData.push(temp);
            }
          }

        })
      },
      open(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        console.log("record:");
        console.log(record);
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(record, 'orgCategory','departName', 'parentId', 'orgCode', 'departOrder', 'mobile', 'fax', 'address', 'memo'));
        });
      },
      clearForm() {
        this.form.resetFields();
        this.treeData = [];
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>